/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The user's preferred visit type
 */
export type PaywallVisitMetadataVisitTypePreference =
  (typeof PaywallVisitMetadataVisitTypePreference)[keyof typeof PaywallVisitMetadataVisitTypePreference];

export const PaywallVisitMetadataVisitTypePreference = {
  chat: "chat",
  audiovisual: "audiovisual",
} as const;
